export default class FloatingForm {
	static init() {
		Array.prototype.forEach.call(document.querySelectorAll('.floating-form'), el => {
			new FloatingForm(el);
		});
	}

	constructor(element) {
		this.element = element;
		let openBtn = element.querySelector('.floating-form__button');
		let closeBtn = element.querySelector('.floating-form__close-btn');

		openBtn.addEventListener('click', () => {
            this.showForm();
		});

		closeBtn.addEventListener('click', () => {
			this.hideForm();
		});

		// if there's a form, handle it
		const form = this.element.querySelector('form');
		if(form) {
			form.addEventListener('submit', (e) => {
				e.preventDefault();

				this.element.classList.add('floating-form--is-submitting');
				this.submitForm(form)
					.then((response) => {
						this.element.classList.remove('floating-form--is-submitting');
						const html = document.createElement('div');
						html.innerHTML = response;
						const error = document.createElement('div');
						error.innerHTML = '<h4 style="color: red">Unknown error</h4>';
						const inner = this.element.querySelector('.floating-form__inner');
						inner.style.height = inner.clientHeight + 'px'; // keep the old size
						inner.style.width = inner.clientWidth + 'px';
						inner.append(html.querySelector('#form-success-message') || error);
						form.remove();
					})
					.catch((e) => {
						form.submit(); // show the error
					});
			});
		}
	}

	showForm() {
		this.element.classList.add('floating-form--expanded');

		// if there's an visible form input, focus
		const input = this.element.querySelector('input:not([type="hidden"])');
		if(input) {
			setTimeout(() => input.focus(), 400);
		}
	}

	hideForm() {
		this.element.classList.remove('floating-form--expanded');
	}

	/**
	 * See https://htmldom.dev/submit-a-form-with-ajax/
	 */
	submitForm(formEle) {
		return new Promise((resolve, reject) => {
			// Serialize form data
			// See https://htmldom.dev/serialize-form-data-into-a-query-string
			const params = this.serializeForm(formEle);

			// Create new Ajax request
			const req = new XMLHttpRequest();
			req.open('POST', formEle.action, true);
			req.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');

			// Handle the events
			req.onload = function() {
				if (req.status >= 200 && req.status < 400) {
					resolve(req.responseText);
				}
			};
			req.onerror = function() {
				reject();
			};

			// Send it
			req.send(params);
		});
	}

	serializeForm(formEle) {
		// Get all fields
		const fields = [].slice.call(formEle.elements, 0);

		return fields
			.map(function(ele) {
				const name = ele.name;
				const type = ele.type;

				// We ignore
				// - field that doesn't have a name
				// - disabled field
				// - `file` input
				// - unselected checkbox/radio
				if (!name ||
					ele.disabled ||
					type === 'file' ||
					(/(checkbox|radio)/.test(type) && !ele.checked))
				{
					return '';
				}

				// Multiple select
				if (type === 'select-multiple') {
					return ele.options
						.map(function(opt) {
							return opt.selected
								? `${encodeURIComponent(name)}=${encodeURIComponent(opt.value)}`
								: '';
						})
						.filter(function(item) {
							return item;
						})
						.join('&');
				}

				return `${encodeURIComponent(name)}=${encodeURIComponent(ele.value)}`;
			})
			.filter(function(item) {
				return item;
			})
			.join('&');
	}
}
